export class DocumentUpdateNotification {
	viewId: number;
	folderId: string;
	documentId: string;

	public static fromJson(other: any): DocumentUpdateNotification {
		const instance = new DocumentUpdateNotification();
		instance.folderId = other.FolderId;
		instance.documentId = other.DocumentId;
		instance.viewId = other.ViewId;
		return instance;
	}
}
